import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Phone, ArrowLeft } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navLinks = [{
    to: '/',
    label: 'Home'
  }, {
    to: '/about',
    label: 'About'
  }, {
    to: '/classes',
    label: 'Classes'
  }, {
    to: '/schedule',
    label: 'Schedule'
  }, {
    to: '/resources',
    label: 'Resources'
  }, {
    to: '/blog',
    label: 'Blog'
  }, {
    to: '/proof',
    label: 'Proof'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <>
      <nav className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 py-3 px-4 shadow-sm" data-id="element-54">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-55">
          {/* Logo */}
          <Link to="/" className="font-black text-xl tracking-tighter text-[#1e3a8a] flex items-center gap-2" data-id="element-56">
            {location.pathname !== '/' && <ArrowLeft className="w-5 h-5" data-id="element-57" />}
            <span data-id="element-58">NWBBA</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6" data-id="element-59">
            {navLinks.slice(1).map(link => <Link key={link.to} to={link.to} className={`text-sm font-semibold transition-colors ${isActive(link.to) ? 'text-[#1e3a8a]' : 'text-gray-600 hover:text-[#1e3a8a]'}`} data-id="element-60">
                {link.label}
              </Link>)}
            <a href="tel:+15555555555" className="flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-[#1e3a8a] transition-colors" data-id="element-61">
              <Phone className="w-4 h-4" data-id="element-62" />
              <span data-id="element-63">Call Us</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-[#1e3a8a] hover:bg-gray-100 rounded-lg transition-colors" aria-label="Toggle menu" data-id="element-64">
            {isOpen ? <X className="w-6 h-6" data-id="element-65" /> : <Menu className="w-6 h-6" data-id="element-66" />}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay - FIXED z-index */}
      <AnimatePresence data-id="element-67">
        {isOpen && <>
            {/* Backdrop */}
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsOpen(false)} className="fixed inset-0 bg-black/50 z-[60] md:hidden" data-id="element-68" />

            {/* Menu Panel */}
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 30,
          stiffness: 300
        }} className="fixed right-0 top-0 bottom-0 w-64 bg-white shadow-2xl z-[70] md:hidden overflow-y-auto" data-id="element-69">
              {/* Close button in menu */}
              <div className="flex justify-between items-center p-4 border-b border-gray-100" data-id="element-70">
                <span className="font-black text-xl text-[#1e3a8a]" data-id="element-71">Menu</span>
                <button onClick={() => setIsOpen(false)} className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-72">
                  <X className="w-5 h-5" data-id="element-73" />
                </button>
              </div>

              <div className="p-6 space-y-1" data-id="element-74">
                {navLinks.map(link => <Link key={link.to} to={link.to} onClick={() => setIsOpen(false)} className={`block px-4 py-3 rounded-lg font-semibold transition-colors ${isActive(link.to) ? 'bg-[#1e3a8a] text-white' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-75">
                    {link.label}
                  </Link>)}

                {/* Call Button */}
                <a href="tel:+15555555555" className="flex items-center gap-2 px-4 py-3 mt-4 bg-[#dc2626] text-white rounded-lg font-semibold hover:bg-red-700 transition-colors" data-id="element-76">
                  <Phone className="w-4 h-4" data-id="element-77" />
                  <span data-id="element-78">Call Us</span>
                </a>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}